import { apiIsomorphicFetchUserEnvironment } from '#/api/userEnvironment/apiFetchUserEnvironment';
import { RouteModule } from '#/horizon/components/RouteModule';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import type { AlgoliaImportedEventHit } from '#/modules/listing/events/algolia/AlgoliaImportedEventHit';
import type { importedEventRoute } from '#/modules/listing/routing/listing.routes';
import { getSearchAlgoliaDefaultConfig } from '#/modules/search/algolia/searchAlgoliaConfig';
import { searchAlgoliaVolopsIndex } from '#/modules/search/algolia/searchAlgoliaVolopsIndex';
import { NotFoundPageLoadable } from '#/pages/NotFound/NotFoundPageLoadable';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';
import { algoliaGetObject } from '#/utils/algolia/algoliaGetObject';

import { ImportedEventPageLoadable } from './ImportedEventPageLoadable';

export const handle = {
  defaultSearchType: 'EVENT',
  showDesktopSearch: true,
  showSearchRefinements: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { source, eventId },
}: HorizonAppRouteLoaderArgs<typeof importedEventRoute>) {
  const { appConfig } = await apiIsomorphicFetchUserEnvironment({
    request,
    context,
  })();

  const [importedEventHit] = await Promise.all([
    algoliaGetObject<AlgoliaImportedEventHit>({
      config: getSearchAlgoliaDefaultConfig({ appConfig }),
      index: searchAlgoliaVolopsIndex({
        sort: 'relevance',
        appConfig,
      }),
      id: `${source.toUpperCase()}_${eventId}`,
      attributes: ['*'],
      isUsingAlgoliaMock: appConfig.algolia.mock,
    }),
    ImportedEventPageLoadable.load(),
  ]);

  return { importedEventHit };
}

export default function ImportedEventHorizonRoute({
  loaderData: { importedEventHit },
}: HorizonAppRouteComponentProps<typeof loader>) {
  if (!importedEventHit) return <NotFoundPageLoadable />;

  return (
    <RouteModule title={importedEventHit.name}>
      <ImportedEventPageLoadable importedEventHit={importedEventHit} />
    </RouteModule>
  );
}
